import {API} from "@/Composables/api";

const sendSupportRequest = async (supportRequest, params = {}) => {
    return API.post(route("support"), params, supportRequest);
};

export {sendSupportRequest};
